import { render } from "./Finalize.vue?vue&type=template&id=3d3f71dc&scoped=true"
import script from "./Finalize.vue?vue&type=script&lang=js"
export * from "./Finalize.vue?vue&type=script&lang=js"

import "./Finalize.vue?vue&type=style&index=0&id=3d3f71dc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d3f71dc"]])

export default __exports__